import { ChevronRightIcon } from '@which/seatbelt/src/components/Icons'

import styles from './LaptopHelperButton.module.scss'

interface LaptopHelperButtonProps {
  onClick: () => void
}

export const LaptopHelperButton = ({ onClick }: LaptopHelperButtonProps) => {
  return (
    <button className={styles.laptopHelperButton} onClick={onClick}>
      <span className={styles.laptopHelperButtonText}>Need help finding your Laptop?</span>
      <ChevronRightIcon className={styles.chevronIcon} />
    </button>
  )
}
